<div nz-flex [nzGap]="'small'" [nzVertical]="true">
  <div class="header-wrapper">
    <h1>Lista kont eWUŚ / Kolce</h1>
  </div>

  <nz-table
    #accountsTable
    [nzData]="searchResult()?.results ?? []"
    [nzBordered]="true"
    [nzLoading]="loading()"
    [nzPageSize]="pageSize"
    [nzPageIndex]="pageIndex"
    [nzTotal]="total"
    [nzFrontPagination]="false"
    (nzQueryParams)="onQueryParamsChange($event)"
    nzTableLayout="fixed"
  >
    <thead>
      <tr>
        <th nzColumnKey="id" [nzSortFn]="true" [nzSortOrder]="'descend'">Id</th>
        <th nzColumnKey="systemType" [nzSortFn]="true">System</th>
        <th nzColumnKey="login" [nzSortFn]="true">Login</th>
        <th nzColumnKey="loginType" [nzSortFn]="true">Typ loginu</th>
        <th nzColumnKey="serviceProviderCode" [nzSortFn]="true">Kod świadczeniodawcy</th>
        <th nzColumnKey="nhfBranchCode" [nzSortFn]="true">Oddział NFZ</th>
        <!-- <th nzColumnKey="ssoLogin" [nzSortFn]="true">SSO Login</th>
        <th nzColumnKey="email" [nzSortFn]="true">Email</th>
        <th nzColumnKey="firstName" [nzSortFn]="true">Imię</th>
        <th nzColumnKey="lastName" [nzSortFn]="true">Nazwisko</th> -->
        <th nzColumnKey="isGlobalAccount" [nzSortFn]="true" class="mhs-center">Globalne</th>
        <th class="mhs-center mhs-table-action-header">Akcja</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let account of accountsTable.data">
        <td>{{ account.id }}</td>
        <td>{{ toSystemTypeLabel(account.systemType!) || '-' }}</td>
        <td>{{ account.login || '-' }}</td>
        <td>{{ toLoginTypeLabel(account.loginType!) || '-' }}</td>
        <td>{{ account.serviceProviderCode || '-' }}</td>
        <td>
          {{ nfzBranchCodes.find((branch) => branch.code === account.nhfBranchCode)?.name || '-' }}
        </td>
        <!-- <td>{{ account.ssoLogin || '-' }}</td>
        <td>{{ account.email || '-' }}</td>
        <td>{{ account.firstName || '-' }}</td>
        <td>{{ account.lastName || '-' }}</td> -->
        <td>
          <div
            class="mhs-boolean-icon"
            [attr.aria-label]="account.isGlobalAccount ? 'Tak' : 'Nie'"
            [title]="account.isGlobalAccount ? 'Tak' : 'Nie'"
          >
            <nz-icon [nzType]="account.isGlobalAccount ? 'check' : 'close'" />
          </div>
        </td>
        <td class="mhs-table-actions-cell" style="text-align: center">
          <div class="mhs-table-actions">
            <a
              nz-dropdown
              [nzDropdownMenu]="userActionsMenu"
              nz-button
              nzType="default"
              nzShape="circle"
            >
              <nz-icon nzType="menu-fold" nzTheme="outline" />
            </a>
            <nz-dropdown-menu #userActionsMenu="nzDropdownMenu">
              <ul nz-menu>
                <li nz-menu-item (click)="changePasswordClick(account.id!)">Zmień hasło</li>
              </ul>
            </nz-dropdown-menu>
          </div>
        </td>
      </tr>
    </tbody>
  </nz-table>
</div>
